export default __webpack_public_path__ + "taster.3045e571.mp4";